import React, { useEffect, useState } from "react";
import "../../../tool-js/ls-productivity-tools.js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getSoeTemplateJson } from "../SoundsOfEnglish/soeService";
import { CircularProgress } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useSelector } from "react-redux";

interface ActivityPlayerElement extends Element {
  definition?: any;
  action?: string;
}
export const LoaderContainer = () => (
  <div data-testid="loader" className="LoaderContainer">
    <div className="loader_img">
      <CircularProgress className="loader" size={35} style={{ color: "primary" }} />
    </div>
  </div>
);

export const BackButton = ({ onClick }: { onClick: () => void }) => (
  <button className="soe-back-button display-flex pointer" data-testid={`soe-back-button`} onClick={onClick}>
    <ArrowBackIosIcon />
    <span className="back-button">Back</span>
  </button>
);

interface RootState {
  soundsOfEnglish: {
    templateTitle: string;
  };
}
const StressAndIntonationTemplate = () => {
  const { templateTitle } = useSelector((state: RootState) => state.soundsOfEnglish);
  const navigate = useNavigate();
  const {templateID } = useParams();
  const { state } = useLocation();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    loadActivityPlayer();
  }, [templateID]);

  const loadActivityPlayer = async () => {
    try {
      let activityPlayerElement = document.querySelector("ls-productivity-tools") as ActivityPlayerElement;

      if (state) {
        const classId = Number(state?.submenu?.ActivityClassId );
        const SelectedActivityId = Number(state?.submenu?.ActivityId );
        const valueId = Number(state?.submenu?.vValue);
        const title = templateTitle;
        const templateType = state?.submenu?.ActivityName;
        setLoading(true);
        const finalDynamicJson = await getSoeTemplateJson(classId, SelectedActivityId, valueId, title, templateType);
        const parsedJson = finalDynamicJson ? JSON.parse(finalDynamicJson) : {};
        activityPlayerElement.definition = parsedJson;
        setLoading(false);
      }
      activityPlayerElement.action = "load";
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };
  return (
    <>
      {loading && <LoaderContainer />}
      <BackButton onClick={() => navigate("/stressandintonation")} />
      <div data-testid={`ls-productivity`}>
        <ls-productivity-tools />
      </div>
    </>
  );
};

export default StressAndIntonationTemplate;
